import React from "react"
import PriceFilter from "../PriceFilter"
import NameFilter from "../NameFilter"
import CheckboxGroup from "../CheckboxGroup"
import CollapsibleFilter from "./CollapsibleFilter"

export const FILTER_RENDERERS = {
  price: ({ min, max, currency, onChange, title, defaultOpen }, t) => (
    <CollapsibleFilter
      key="price"
      title={title ?? t("admiralsite.filter_by_price")}
      defaultOpen={defaultOpen}
    >
      <PriceFilter min={min} max={max} currency={currency} onChange={onChange} />
    </CollapsibleFilter>
  ),

  name: ({ value, onChange, filterKey = "name", placeholder, title, defaultOpen }, t) => (
    <CollapsibleFilter key="name" title={title ?? t("admin.name")} defaultOpen={defaultOpen}>
      <NameFilter value={value} onChange={onChange} placeholder={placeholder} />
    </CollapsibleFilter>
  ),

  checkbox: ({ title, options, onChange, filterKey, defaultOpen }) => {
    const visibleOptions = options.filter((o) => o.count > 0 || o.checked)

    if (visibleOptions.length === 0) return null

    return (
      <CollapsibleFilter key={filterKey} title={title} defaultOpen={defaultOpen}>
        <CheckboxGroup
          options={visibleOptions}
          onChange={(value) => onChange({ key: filterKey, value })}
        />
      </CollapsibleFilter>
    )
  },
}

const renderFilters = (filterConfig, t) =>
  filterConfig.map((config) => {
    const renderer = FILTER_RENDERERS[config.type]
    return renderer ? renderer(config, t) : null
  })

export default renderFilters
